import { Construction as icon } from "lucide-react"

import create from "./projects.create"
import edit from "./projects.edit"
import list from "./projects.list"
import { ProjectRecord } from "./projects.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "projects",
  options: { label: "Projects" },
  create:
    "projects" in permissions && permissions.projects.includes("create")
      ? create
      : undefined,
  list:
    "projects" in permissions && permissions.projects.includes("list")
      ? list
      : undefined,
  edit:
    "projects" in permissions && permissions.projects.includes("edit")
      ? edit
      : undefined,
  icon,

  recordRepresentation: (record: ProjectRecord): string => record.title,
})

export default crud
